import HorizontalDivider from './horizontal';
import VerticalDivider from './vertical';

export { HorizontalDivider, VerticalDivider };
